import { StaticQuery, graphql } from 'gatsby';
import _, { startCase, flattenDeep } from 'lodash';
import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';

import { H3, H4, H5, H6 } from '../Type/Display.h';
import LinkCSS from '../Links/A.css';
import Page from '../Layout/Page.div';
import PluginSearchBar from '../Inputs/PluginSearchBar';

const LinkListingPanel = styled.div`
  background: ${props => props.theme.colors.white['800']};
  div.prompt {
    margin-right: 1em;
    margin-bottom: 2em;
    max-width: 240px;
  }
  div.content {
    width: 100%;
  }
  div.links {
    display: flex;
    margin: 2em 0;
  }
  & > div.wrapper {
    display: flex;
    justify-content: center;
    max-width: 1080px;
    margin: 0 auto;
    padding: 3em 1em;
    & > div {
      display: flex;
      flex-direction: column;
    }
    div.list {
      margin: 0 .5em;
      line-height: 110%;
      margin-bottom: 2em;
      h5 {
        border-bottom: 1px solid ${props => props.theme.colors.white['300']};
        padding-bottom: 0.5em;
      }
    }
    a {
      ${LinkCSS}
      font-size: 14px;
    }
    li, p {
      font-size: 0.9em;
      margin-bottom: 1.5em;
    }
  }
  @media screen and (max-width: 45em) {
    & > div.wrapper {
      flex-direction: column;
    }
    div.prompt {
      max-width: 100%;
    }
    .links {
      flex-direction: column;
    }
  }
`;

const LearnListingPanel = () => (
  <StaticQuery
    query={graphql`
      query LearnListingPanelQuery {
        allContentfulLearnArticle(
          sort: { fields: [publishedAt], order: DESC }
          filter: { featured: { eq: true } },
        ) {
          edges {
            node {
              id
              slug
              title
              publishedAt
              articleCategorys
              featured
            }
          }
        }
      }
    `}
    render={(data) => {
      const articles = data.allContentfulLearnArticle.edges.map(e => e.node);
      const tags = Array.from(new Set(flattenDeep(articles.map(a => a.articleCategorys)))).filter(t => t != null);
      let columns = [
        [],
        [],
        [],
        [],
      ];
      tags.forEach((tag) => {
        const tagArticles = [...articles.filter(a => (a.articleCategorys || []).includes(tag))];
        columns = columns.sort((a, b) => _.flatten(a).length - _.flatten(b).length);
        columns[0].push({ tag, tagArticles });
      });

      return (
        <LinkListingPanel>
          <div className="wrapper">
            <div className="prompt">
              <H3>Questions about bankruptcy?</H3>
              <p>Research and understand your options with our articles and guides.</p>
              <a href="/learn">Go to Learning Center →</a>
              <br />
              <H4>Questions about Upsolve?</H4>
              <a href="/learn/category/support/">Read Support Articles →</a>
            </div>
            <div className="content">
              <div className="links">
                {Array.prototype.map.call(columns, (column, colIndex) => {
                  return (
                    <div key={colIndex}>
                      {Array.prototype.map.call(column, (bucket) => {
                        return (
                          <div key={bucket.tag} className="list">
                            <h5>{startCase(bucket.tag)}</h5>
                            <ul>
                              {Array.prototype.map.call(bucket.tagArticles, (article) => {
                                return (
                                  <li key={article.slug}>
                                    <a href={`/learn/${article.slug}/`}>{startCase(article.slug)}</a>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </LinkListingPanel>
      );
    }}
  />
);

export default LearnListingPanel;
